import { GuestMessage } from './guestMessage.component';
import { PostCheckoutModalComponent } from './postCheckoutModal.component';

export const CompleteModule = angular.module('oo.checkout.complete', [])
    .component('guestMessage', GuestMessage)
    .component('postCheckoutModal', PostCheckoutModalComponent)
    .name;
